import { render } from "./OrderCheckout.vue?vue&type=template&id=2c116ed3&scoped=true&ts=true"
import script from "./OrderCheckout.vue?vue&type=script&lang=ts"
export * from "./OrderCheckout.vue?vue&type=script&lang=ts"

import "./OrderCheckout.vue?vue&type=style&index=0&id=2c116ed3&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c116ed3"]])

export default __exports__